<template>
  <div>
    <div class="main">
      <div class="d_title">配资交易规则</div>
      <div class="d_con" v-html="info"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Operateprotocol",
  data() {
    return {
      info: ""
    };
  },
  components: {},
  mounted() {
    let that = this;
    that
      .$http({
        url: "/",
        method: "post",
        data: {
          'nozzle': 'protocol',
          'type': 14,
        }
      })
      .then(function(res) {
        if (res.data.code == 1) {
          that.info = res.data.data;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(res.data.msg);
        }
      });
  },
  methods: {}
};
</script>
<style scoped>
.main {
  width: 1000px;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 0 16px 16px;
  margin-bottom: 20px;
}
.d_title {
  font-size: 18px;
  text-align: center;
  padding: 20px 0 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/operateprotocol.vue